import { API_BASE_URL } from "../../api/api";

export const CardProductOrder = ({ order }) => {
  if (!order?.items?.length) return null;

  const totalRoyalty = order.items.reduce(
    (acc, item) => acc + (item.loyalty_points * item.quantity),
    0
  );
  const totalBonus = order.items.reduce(
    (acc, item) => acc + (item.influencer_bonus * item.quantity),
    0
  );

  return (
    <div className="ui-card">
      <h3 style={{ margin: "0 0 16px", fontSize: 15, fontWeight: 700 }}>Productos</h3>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {order.items.map((item) => {
          const product = item.product_id;
          const image = product?.images?.[product.mainImage] || product?.images?.[0];

          return (
            <div className="ui-product-row" key={item.id}>
              {image && (
                <img
                  className="ui-product-row__thumb"
                  src={`${API_BASE_URL}/product/get/file/${image}`}
                  alt={product.title}
                />
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="ui-product-row__name">{product?.title}</div>
                <div className="ui-product-row__sku">
                  {item.loyalty_points * item.quantity} pts regalía · {item.influencer_bonus * item.quantity} pts bono
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div className="ui-product-row__meta">{item.quantity} × ${item.price.toLocaleString()}</div>
                <div className="ui-product-row__total">${(item.price * item.quantity).toLocaleString()}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 14,
          paddingTop: 14,
          borderTop: "1px solid #EDEFF6",
          fontSize: 12.5,
        }}
      >
        <span style={{ color: "#5A6187" }}>Totales de puntos</span>
        <span style={{ fontWeight: 700 }}>{totalRoyalty} pts regalía · {totalBonus} pts bono</span>
      </div>
    </div>
  );
};
